<mat-form-field class="w-full">
  <mat-label>{{ label() }}</mat-label>

  <textarea
    matInput
    [formControl]="control()"
    [placeholder]="placeholder()"
  >
  </textarea>

  @if (control().invalid) {
    <mat-error>{{ errorMsg() }}</mat-error>
  }
</mat-form-field>
